FiltersMdl.controller( 'MobileCtrl', ['MobileFiltersSrv', function ( MobileFiltersSrv ) {

	this.filterOn = true;
	this.searchOn = false;

	this.toggleFilters = function( display_filter ) {

		if ( display_filter === 'filterOn') {
			this.filterOn = !this.filterOn;
			this.searchOn = false;
		}
		else {
			this.searchOn = ! this.searchOn;
			this.filterOn = false;
		}


		MobileFiltersSrv.filterOn = this.filterOn;
		MobileFiltersSrv.searchOn = this.searchOn;

	}
}]);


